<div class="account-settings-page">
  <h1 class="page-title">{{ 'ACCOUNT_SETTINGS.TITLE' | translate }}</h1>

  <div data-tour="account-settings-overview">
  <nz-tabset
    *ngIf="isMobile"
    [nzSelectedIndex]="selectedTabIndex"
    (nzSelectedIndexChange)="onMobileTabChange($event)"
    class="settings-tabs"
  >
    <nz-tab *ngFor="let section of sections" [nzTitle]="section.labelKey | translate"></nz-tab>
  </nz-tabset>

  <div class="settings-layout" [class.mobile]="isMobile">
    <aside class="settings-nav" *ngIf="!isMobile">
      <ul nz-menu nzMode="inline">
        <li
          nz-menu-item
          *ngFor="let section of sections"
          [routerLink]="section.route"
          [nzMatchRouter]="true"
          [nzMatchRouterExact]="false"
        >
          <span nz-icon [nzType]="section.icon"></span>
          <span>{{ section.labelKey | translate }}</span>
        </li>
      </ul>
    </aside>

    <section class="settings-content">
      <router-outlet></router-outlet>
    </section>
  </div>
  </div>
</div>
